// Generated from the official Menury menu source on 2026-07-17. Do not hand-edit.
import type { Category, MenuItem } from "../types";

export const menuCategories: Category[] = [
  {
    "id": "54776-unsere-speisen",
    "title": "Unsere Speisen",
    "parentId": null,
    "order": 0,
    "active": true,
    "featured": false
  },
  {
    "id": "54770-mezze",
    "title": "Mezze",
    "description": "Unsere Mezze-Tradition - Anatolien in seiner schönsten Form!",
    "parentId": "54776-unsere-speisen",
    "order": 1,
    "active": true,
    "featured": false
  },
  {
    "id": "54616-kalte-mezze",
    "title": "Kalte Mezze",
    "parentId": "54770-mezze",
    "order": 1,
    "active": true,
    "featured": true
  },
  {
    "id": "54771-warme-mezze",
    "title": "Warme Mezze",
    "parentId": "54770-mezze",
    "order": 2,
    "active": true,
    "featured": false
  },
  {
    "id": "54773-sharing-menus",
    "title": "Sharing Menüs",
    "description": "Unsere Sharing-Menüs laden ein: Vielfältige Mezze, aromatisches vom Grill, gemeinsam genießen!",
    "parentId": "54776-unsere-speisen",
    "order": 3,
    "active": true,
    "featured": true
  },
  {
    "id": "54620-fleisch-vom-grill",
    "title": "Fleisch - vom Grill",
    "description": "hochwertiges Fleisch vom Besten Teil des Tieres zeichnen unsere Signature-Gerichte aus.",
    "parentId": "54776-unsere-speisen",
    "order": 4,
    "active": true,
    "featured": false
  },
  {
    "id": "54677-mezze-zu-raki",
    "title": "Mezze zu Raki",
    "description": "Raki liebt Mezze. Hier sind unsere Raki-Favoriten aus der Mezze-Bar",
    "parentId": "54770-mezze",
    "order": 5,
    "active": true,
    "featured": false
  },
  {
    "id": "54619-fisch-aus-dem-meer",
    "title": "Fisch - aus dem Meer",
    "description": "wir servieren nur frischen Fisch, täglich wechselnde Sorten, fragt nach!",
    "parentId": "54776-unsere-speisen",
    "order": 6,
    "active": true,
    "featured": false
  },
  {
    "id": "54774-extras-salate",
    "title": "Extras & Salate",
    "parentId": "54776-unsere-speisen",
    "order": 7,
    "active": true,
    "featured": false
  },
  {
    "id": "54775-dessert",
    "title": "Dessert",
    "description": "Save a little space for later",
    "parentId": "54776-unsere-speisen",
    "order": 8,
    "active": true,
    "featured": false
  },
  {
    "id": "54772-unsere-getranke",
    "title": "Unsere Getränke",
    "parentId": null,
    "order": 5,
    "active": true,
    "featured": false
  },
  {
    "id": "54673-aperetifs",
    "title": "Aperetifs",
    "description": "- zum Ankommen",
    "parentId": "54772-unsere-getranke",
    "order": 9,
    "active": true,
    "featured": false
  },
  {
    "id": "54674-signature-drinks",
    "title": "Signature Drinks",
    "parentId": "54772-unsere-getranke",
    "order": 10,
    "active": true,
    "featured": false
  },
  {
    "id": "54679-alkoholfreies",
    "title": "Alkoholfreies",
    "parentId": "54772-unsere-getranke",
    "order": 11,
    "active": true,
    "featured": false
  },
  {
    "id": "54681-biere",
    "title": "Biere",
    "parentId": "54772-unsere-getranke",
    "order": 12,
    "active": true,
    "featured": false
  },
  {
    "id": "54683-kaffe-tee",
    "title": "Kaffe & Tee",
    "parentId": "54772-unsere-getranke",
    "order": 13,
    "active": true,
    "featured": false
  },
  {
    "id": "54676-raki",
    "title": "RAKI",
    "description": "Raki ist eine über 500 Jahre alte Kultur und fester Bestandteil der türkischen Küche.",
    "parentId": "54772-unsere-getranke",
    "order": 14,
    "active": true,
    "featured": true
  },
  {
    "id": "54675-weine",
    "title": "Weine",
    "parentId": "54772-unsere-getranke",
    "order": 15,
    "active": true,
    "featured": false
  },
  {
    "id": "54787-fur-unsere-kids",
    "title": "Für unsere Kids",
    "description": "für unsere jüngeren Gäste bis 12 Jahre",
    "parentId": null,
    "order": 16,
    "active": true,
    "featured": false
  }
];

export const menuItems: MenuItem[] = [
  {
    "id": "410683-mutebbel",
    "title": "Mütebbel",
    "description": "geräucherte Aubergine / Joghurt / Walnuss / Tahini / Granatapfelsirup / Zitrone",
    "categoryIds": [
      "54616-kalte-mezze"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 6.5
      }
    ],
    "extras": [],
    "attributes": [
      "Vegetarisch",
      "Milch und Milcherzeugnisse",
      "Walnüsse",
      "Sesamsamen und Sesamerzeugnisse"
    ],
    "allergens": [
      "Milch und Milcherzeugnisse",
      "Walnüsse",
      "Sesamsamen und Sesamerzeugnisse"
    ],
    "imageUrls": [],
    "order": 2,
    "active": true,
    "featured": false
  },
  {
    "id": "410684-cevizli-kabak",
    "title": "Cevizli Kabak",
    "description": "geraspelte Zucchini / Apfel / Walnuss / Joghurt",
    "categoryIds": [
      "54616-kalte-mezze"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 6.5
      }
    ],
    "extras": [],
    "attributes": [
      "Vegetarisch",
      "Milch und Milcherzeugnisse",
      "Walnüsse"
    ],
    "allergens": [
      "Milch und Milcherzeugnisse",
      "Walnüsse"
    ],
    "imageUrls": [],
    "order": 3,
    "active": true,
    "featured": false
  },
  {
    "id": "410685-girit-ezme",
    "title": "Girit Ezme",
    "description": "Schafskäse / Basilikum / Olivenöl / Pistazie",
    "categoryIds": [
      "54616-kalte-mezze"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 6.5
      }
    ],
    "extras": [],
    "attributes": [
      "Vegetarisch",
      "Milch und Milcherzeugnisse",
      "Cashewnüsse"
    ],
    "allergens": [
      "Milch und Milcherzeugnisse",
      "Cashewnüsse"
    ],
    "imageUrls": [],
    "order": 4,
    "active": true,
    "featured": false
  },
  {
    "id": "410688-kopoglu",
    "title": "Köpoglu",
    "description": "frittierte Gemüsewürfel (Kartoffel, Aubergine, Paprika) / Tomatensauce / Joghurt / Knoblauch ( optional vegan)",
    "categoryIds": [
      "54616-kalte-mezze"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 6.5
      }
    ],
    "extras": [],
    "attributes": [
      "Vegetarisch",
      "Milch und Milcherzeugnisse"
    ],
    "allergens": [
      "Milch und Milcherzeugnisse"
    ],
    "imageUrls": [],
    "order": 5,
    "active": true,
    "featured": false
  },
  {
    "id": "410691-tarator",
    "title": "Tarator",
    "description": "gebratene Karotte / Joghurt / Knoblauch / Olivenöl",
    "categoryIds": [
      "54616-kalte-mezze"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 6.5
      }
    ],
    "extras": [],
    "attributes": [
      "Vegetarisch",
      "Milch und Milcherzeugnisse"
    ],
    "allergens": [
      "Milch und Milcherzeugnisse"
    ],
    "imageUrls": [],
    "order": 7,
    "active": true,
    "featured": false
  },
  {
    "id": "410692-antalya-piaz",
    "title": "Antalya Piaz",
    "description": "weiße Bohnen / Butter / Tahini / rote Zwiebeln / Kräuter",
    "categoryIds": [
      "54616-kalte-mezze"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 6.5
      }
    ],
    "extras": [],
    "attributes": [
      "Vegan"
    ],
    "allergens": [],
    "imageUrls": [],
    "order": 8,
    "active": true,
    "featured": false
  },
  {
    "id": "410693-hummus",
    "title": "Hummus",
    "description": "Kichererbsen / Sesam / Zitrone / Tahini",
    "categoryIds": [
      "54616-kalte-mezze"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 6.5
      }
    ],
    "extras": [
      {
        "id": "extra-1",
        "label": "mit Pastrami",
        "price": 2
      }
    ],
    "attributes": [
      "Vegan",
      "Mandeln",
      "Sesamsamen und Sesamerzeugnisse"
    ],
    "allergens": [
      "Mandeln",
      "Sesamsamen und Sesamerzeugnisse"
    ],
    "imageUrls": [],
    "order": 9,
    "active": true,
    "featured": false
  },
  {
    "id": "410695-muhammara",
    "title": "Muhammara",
    "description": "geröstete Parika /  getrockente Tomaten / Walnuss / Granatapfel / Schafskäse",
    "categoryIds": [
      "54616-kalte-mezze"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 6.5
      }
    ],
    "extras": [],
    "attributes": [
      "Walnüsse",
      "Vegetarisch"
    ],
    "allergens": [
      "Walnüsse"
    ],
    "imageUrls": [],
    "order": 10,
    "active": true,
    "featured": false
  },
  {
    "id": "410696-fava",
    "title": "Fava",
    "description": "Fava  ( Saubohnenpüree )/ karamellisierte Zwiebeln / Olivenöl / Petersilie / Kapern",
    "categoryIds": [
      "54616-kalte-mezze"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 6.5
      }
    ],
    "extras": [],
    "attributes": [
      "Vegan"
    ],
    "allergens": [],
    "imageUrls": [],
    "order": 11,
    "active": true,
    "featured": false
  },
  {
    "id": "410701-all-in-the-middle",
    "title": "All IN THE MIDDLE",
    "description": "MEZZE ZUM TEILEN - Je voller der Tisch, desto schöner der Abend.",
    "categoryIds": [
      "54616-kalte-mezze"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "Tadina Bacacaktik - wir wollen nur einmal probieren! 3 kalte Mezze nach Wahl",
        "price": 17.5
      },
      {
        "id": "variante-2",
        "label": "Kafana Göre Takil - \"Entscheide Du für mich\" 6 kalte Mezze nach Wahl",
        "price": 34.5
      },
      {
        "id": "variante-3",
        "label": "Masayi Donat - \"Füll den Tisch\" 9 kalte Mezze nach Wahl",
        "price": 54.5
      },
      {
        "id": "variante-4",
        "label": "Yok Artik - \"Das gibt es doch nicht!\" 12 kalte Mezze nach Wahl",
        "price": 74.5
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 1,
    "active": true,
    "featured": true
  },
  {
    "id": "410704-garnelen-mit-chilli",
    "title": "Garnelen mit Chilli",
    "description": "Riesengarnelen mit Schwanz / Chilli / Knoblauch / Kräuter / Zitrone / Butter mit Grillgemüse & Pfannenkartoffeln",
    "categoryIds": [
      "54619-fisch-aus-dem-meer"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 18.9
      }
    ],
    "extras": [],
    "attributes": [
      "Weichtiere und Weichtiererzeugnisse",
      "Schalenfrüchte und Schalenfruchterzeugnisse"
    ],
    "allergens": [
      "Weichtiere und Weichtiererzeugnisse",
      "Schalenfrüchte und Schalenfruchterzeugnisse"
    ],
    "imageUrls": [],
    "order": 1,
    "active": true,
    "featured": false
  },
  {
    "id": "410706-gegrillter-pulpo",
    "title": "Gegrillter Pulpo",
    "description": "zart gegrillte Oktopus-Tentakel und in der Pfanne mit Grillgemüse / Zitrone / Knoblauch / mediterranen Kräuter geschwenkt / Hummusspiegel",
    "categoryIds": [
      "54619-fisch-aus-dem-meer"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 20.9
      }
    ],
    "extras": [],
    "attributes": [
      "Fisch und Fischerzeugnisse"
    ],
    "allergens": [
      "Fisch und Fischerzeugnisse"
    ],
    "imageUrls": [],
    "order": 3,
    "active": true,
    "featured": false
  },
  {
    "id": "410707-gegrillter-wolfsbarsch-wildfang",
    "title": "Gegrillter Wolfsbarsch - Wildfang",
    "description": "gegrilltes Wolfsbarschfilet auf Haut / hauseigene Kräutermischung / Zitrone /  Grünes / cremiger Joghurt-Möhren-Salat / geröstetes Brot",
    "categoryIds": [
      "54619-fisch-aus-dem-meer"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 23.9
      }
    ],
    "extras": [],
    "attributes": [
      "Fisch und Fischerzeugnisse"
    ],
    "allergens": [
      "Fisch und Fischerzeugnisse"
    ],
    "imageUrls": [],
    "order": 4,
    "active": true,
    "featured": false
  },
  {
    "id": "410708-gegrillte-dorade",
    "title": "Gegrillte Dorade",
    "description": "im Ganzen gegrillte Dorade / hauseigene Kräutermischung / Zitrone / Grünes / cremiger Joghurt - Möhren - Salat / geröstetes Brot",
    "categoryIds": [
      "54619-fisch-aus-dem-meer"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 23.9
      }
    ],
    "extras": [],
    "attributes": [
      "Fisch und Fischerzeugnisse"
    ],
    "allergens": [
      "Fisch und Fischerzeugnisse"
    ],
    "imageUrls": [],
    "order": 5,
    "active": true,
    "featured": false
  },
  {
    "id": "410709-rinderfiletsteak",
    "title": "Rinderfiletsteak",
    "description": "das zarteste Stück vom Rind - saftig gegrillt / serviert mit Pfannenkartoffeln / Grillgemüse /  hausgemachter Knoblauchbutter",
    "categoryIds": [
      "54620-fleisch-vom-grill"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "200g",
        "price": 29.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 1,
    "active": true,
    "featured": false
  },
  {
    "id": "410710-ortayas-cokertme-kebab",
    "title": "ORTAYAS Cökertme Kebab",
    "description": "saftig gegrillte Rinderköfte / Fladenbrot-Croutons / Joghurt / Tomatensauce / Kartoffelraspeln / Paprikabutter / Sesam und Knoblauch",
    "categoryIds": [
      "54620-fleisch-vom-grill"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 19.9
      }
    ],
    "extras": [],
    "attributes": [
      "Weizen",
      "Milch und Milcherzeugnisse",
      "Sesamsamen und Sesamerzeugnisse"
    ],
    "allergens": [
      "Weizen",
      "Milch und Milcherzeugnisse",
      "Sesamsamen und Sesamerzeugnisse"
    ],
    "imageUrls": [],
    "order": 2,
    "active": true,
    "featured": false
  },
  {
    "id": "411060-entrecote",
    "title": "Entrecôte",
    "description": "fein marmoriertes Premium-Steak vom Grill / Pfannenkartoffeln / Grillgemüse und hausgemachter Knoblauchbutter",
    "categoryIds": [
      "54620-fleisch-vom-grill"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "200g",
        "price": 26.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 3,
    "active": true,
    "featured": false
  },
  {
    "id": "411061-meyhane-kofte",
    "title": "Meyhane - Köfte",
    "description": "Würzige Rinderköfte nach Meyhane-Art frisch vom Grill / Butterreis / Sumac-Zwiebeln und Grünes",
    "categoryIds": [
      "54620-fleisch-vom-grill"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 14.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 4,
    "active": true,
    "featured": false
  },
  {
    "id": "411062-hahnchenfilet",
    "title": "Hähnchenfilet",
    "description": "Mariniertes Hähnchenfilet auf gegrilltem Pitabrot / Salat / Pfannenkartoffeln",
    "categoryIds": [
      "54620-fleisch-vom-grill"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 14.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 5,
    "active": true,
    "featured": false
  },
  {
    "id": "411064-espresso-tonic",
    "title": "Espresso Tonic",
    "description": "Espresso trifft auf spritziges Tonic - bittersüß, erfrischend und der perfekte Sommerdrink.",
    "categoryIds": [
      "54673-aperetifs"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 7.5
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 2,
    "active": true,
    "featured": false
  },
  {
    "id": "411065-limoncello-sprizz",
    "title": "Limoncello Sprizz",
    "description": "Limoncello / Secco / Soda",
    "categoryIds": [
      "54673-aperetifs"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 7.5
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 3,
    "active": true,
    "featured": false
  },
  {
    "id": "411066-anatolian-sprizz",
    "title": "Anatolian Sprizz",
    "description": "Granatapfel / Orange / Secco / Soda",
    "categoryIds": [
      "54673-aperetifs"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 7.5
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 1,
    "active": true,
    "featured": false
  },
  {
    "id": "411069-aperol-sprizz",
    "title": "Aperol Sprizz",
    "description": "Aperol / Secco / Soda",
    "categoryIds": [
      "54673-aperetifs"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 7.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 6,
    "active": true,
    "featured": false
  },
  {
    "id": "411070-dejavu-sprizz",
    "title": "Dejavu Sprizz",
    "description": "Dejavu / Secco / White Peach",
    "categoryIds": [
      "54673-aperetifs"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 7.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 7,
    "active": true,
    "featured": false
  },
  {
    "id": "411071-limonata",
    "title": "LIMONATA",
    "description": "frische Zitronen / Minze / weißer Rohrzucker / Soda",
    "categoryIds": [
      "54674-signature-drinks"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 3.5
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 1,
    "active": true,
    "featured": false
  },
  {
    "id": "411072-basilikum-ayran",
    "title": "BASILIKUM-AYRAN",
    "description": "kühles Joghurtgetränk / frischer Basilikum",
    "categoryIds": [
      "54674-signature-drinks"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 3.5
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 2,
    "active": true,
    "featured": false
  },
  {
    "id": "411073-chardonnay-no-5",
    "title": "Chardonnay No.5",
    "categoryIds": [
      "54675-weine"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "0,2 l",
        "price": 7.5
      },
      {
        "id": "variante-2",
        "label": "0,75 l",
        "price": 19.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 1,
    "active": true,
    "featured": false
  },
  {
    "id": "411074-lugana-doc",
    "title": "Lugana DOC",
    "categoryIds": [
      "54675-weine"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "0,2 l",
        "price": 8.5
      },
      {
        "id": "variante-2",
        "label": "0,75 l",
        "price": 22.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 2,
    "active": true,
    "featured": false
  },
  {
    "id": "411075-grauburgunder-qba",
    "title": "Grauburgunder QbA",
    "categoryIds": [
      "54675-weine"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "0,2 l",
        "price": 8.9
      },
      {
        "id": "variante-2",
        "label": "0,75 l",
        "price": 23.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 3,
    "active": true,
    "featured": false
  },
  {
    "id": "411076-la-marca-prossecco",
    "title": "La Marca Prossecco",
    "description": "D.O.C. Treviso Vino Frizzante",
    "categoryIds": [
      "54675-weine"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "0,15 l",
        "price": 5.9
      },
      {
        "id": "variante-2",
        "label": "0,75 l",
        "price": 26.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 4,
    "active": true,
    "featured": false
  },
  {
    "id": "411077-la-marca-prossecco-rose",
    "title": "La Marca Prossecco Rose",
    "categoryIds": [
      "54675-weine"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "0,15 l",
        "price": 5.9
      },
      {
        "id": "variante-2",
        "label": "0,75 l",
        "price": 26.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 5,
    "active": true,
    "featured": false
  },
  {
    "id": "411078-beylerbeyi-gobek",
    "title": "Beylerbeyi Göbek",
    "categoryIds": [
      "54676-raki"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "5 cl",
        "price": 7.5
      },
      {
        "id": "variante-2",
        "label": "20 cl",
        "price": 21
      },
      {
        "id": "variante-3",
        "label": "35 cl",
        "price": 36
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 1,
    "active": true,
    "featured": false
  },
  {
    "id": "411079-tekirdag-gold",
    "title": "Tekirdag Gold",
    "categoryIds": [
      "54676-raki"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "5 cl",
        "price": 7.5
      },
      {
        "id": "variante-2",
        "label": "20 cl",
        "price": 21
      },
      {
        "id": "variante-3",
        "label": "35 cl",
        "price": 36
      },
      {
        "id": "variante-4",
        "label": "0,75 l",
        "price": 48
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 2,
    "active": true,
    "featured": false
  },
  {
    "id": "411081-efe-gobek",
    "title": "Efe Göbek",
    "categoryIds": [
      "54676-raki"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "4 cl",
        "price": 7.5
      },
      {
        "id": "variante-2",
        "label": "20 cl",
        "price": 21
      },
      {
        "id": "variante-3",
        "label": "35 cl",
        "price": 36
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 4,
    "active": true,
    "featured": false
  },
  {
    "id": "411082-yeni-raki-yeni-seri",
    "title": "YENI RAKI Yeni Seri",
    "categoryIds": [
      "54676-raki"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "5 cl",
        "price": 6.5
      },
      {
        "id": "variante-2",
        "label": "20 cl",
        "price": 21
      },
      {
        "id": "variante-3",
        "label": "35 cl",
        "price": 38
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 5,
    "active": true,
    "featured": false
  },
  {
    "id": "411083-zebybek-sari",
    "title": "Zebybek Sari",
    "categoryIds": [
      "54676-raki"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "5 cl",
        "price": 7.5
      },
      {
        "id": "variante-2",
        "label": "20 cl",
        "price": 21
      },
      {
        "id": "variante-3",
        "label": "35 cl",
        "price": 36
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 6,
    "active": true,
    "featured": false
  },
  {
    "id": "411084-ezine-kase-melone",
    "title": "Ezine Käse & Melone",
    "categoryIds": [
      "54677-mezze-zu-raki"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 10.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 1,
    "active": true,
    "featured": false
  },
  {
    "id": "411085-zeytinyali-enginar",
    "title": "Zeytinyali Enginar",
    "description": "Artischokenherzen /Dill / Olivenöl / Zitrone",
    "categoryIds": [
      "54677-mezze-zu-raki"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 8.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 2,
    "active": true,
    "featured": false
  },
  {
    "id": "411086-yaprak-cigeri",
    "title": "Yaprak Cigeri",
    "description": "ein echter Klassiker: zarte Rinderleber, rote Zwiebeln, frische Petersilie",
    "categoryIds": [
      "54677-mezze-zu-raki"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 12.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 3,
    "active": true,
    "featured": false
  },
  {
    "id": "411087-kalamar",
    "title": "Kalamar",
    "description": "selbstgemachte Kalamar-Ringe, Zitrone, Aioli",
    "categoryIds": [
      "54677-mezze-zu-raki"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 9.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 4,
    "active": true,
    "featured": false
  },
  {
    "id": "411089-antalya-piyaz",
    "title": "Antalya Piyaz",
    "categoryIds": [
      "54677-mezze-zu-raki"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 7.5
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 6,
    "active": true,
    "featured": false
  },
  {
    "id": "411092-aqua",
    "title": "Aqua",
    "description": "naturell oder sprudelnd",
    "categoryIds": [
      "54679-alkoholfreies"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "0,25l",
        "price": 3.5
      },
      {
        "id": "variante-2",
        "label": "0,75l",
        "price": 6.2
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 1,
    "active": true,
    "featured": false
  },
  {
    "id": "411094-pepsi-cola",
    "title": "Pepsi Cola",
    "description": "Cola / Max / Mirinda / 7Up",
    "categoryIds": [
      "54679-alkoholfreies"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "0,3 l",
        "price": 3.6
      },
      {
        "id": "variante-2",
        "label": "0,4 l",
        "price": 4.6
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 2,
    "active": true,
    "featured": false
  },
  {
    "id": "411097-safte",
    "title": "Säfte",
    "description": "Apfel / Rhababer / Maracuja",
    "categoryIds": [
      "54679-alkoholfreies"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "0,3 l",
        "price": 3.5
      },
      {
        "id": "variante-2",
        "label": "0,4 l",
        "price": 4.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 3,
    "active": true,
    "featured": false
  },
  {
    "id": "411099-ice-tea",
    "title": "Ice Tea",
    "description": "Pfirsich / Granatapfel",
    "categoryIds": [
      "54679-alkoholfreies"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "0,33 l",
        "price": 4.5
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 4,
    "active": true,
    "featured": false
  },
  {
    "id": "411100-gazoz",
    "title": "Gazoz",
    "categoryIds": [
      "54679-alkoholfreies"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "0,2 l",
        "price": 2.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 5,
    "active": true,
    "featured": false
  },
  {
    "id": "411101-beck-s-bier",
    "title": "Beck's Bier",
    "categoryIds": [
      "54681-biere"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "0,3 l",
        "price": 3.6
      },
      {
        "id": "variante-2",
        "label": "0,4 l",
        "price": 4.6
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 1,
    "active": true,
    "featured": false
  },
  {
    "id": "411103-munchner-spaten",
    "title": "Münchner Spaten",
    "categoryIds": [
      "54681-biere"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "0,3 l",
        "price": 3.6
      },
      {
        "id": "variante-2",
        "label": "0,4 l",
        "price": 4.6
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 2,
    "active": true,
    "featured": false
  },
  {
    "id": "411104-franziskaner-hefeweizen",
    "title": "Franziskaner Hefeweizen",
    "description": "hell",
    "categoryIds": [
      "54681-biere"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "0,3 l",
        "price": 3.6
      },
      {
        "id": "variante-2",
        "label": "0,5 l",
        "price": 4.6
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 3,
    "active": true,
    "featured": false
  },
  {
    "id": "411105-corona-mex",
    "title": "Corona, MEX",
    "categoryIds": [
      "54681-biere"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "0,33 l",
        "price": 4.5
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 4,
    "active": true,
    "featured": false
  },
  {
    "id": "411107-beck-s-alkoholfrei",
    "title": "Beck's alkoholfrei",
    "categoryIds": [
      "54681-biere"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "0,33 l",
        "price": 3.5
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 5,
    "active": true,
    "featured": false
  },
  {
    "id": "411108-franziskaner-alkoholfrei",
    "title": "Franziskaner Alkoholfrei",
    "categoryIds": [
      "54681-biere"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "0,5 l",
        "price": 5.5
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 6,
    "active": true,
    "featured": false
  },
  {
    "id": "411109-turk-kahvesi",
    "title": "Türk Kahvesi",
    "categoryIds": [
      "54683-kaffe-tee"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 3.5
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 1,
    "active": true,
    "featured": false
  },
  {
    "id": "411110-cafe-creme",
    "title": "Cafe Crème",
    "categoryIds": [
      "54683-kaffe-tee"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 2.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 2,
    "active": true,
    "featured": false
  },
  {
    "id": "411111-latte-macciato",
    "title": "Latte Macciato",
    "categoryIds": [
      "54683-kaffe-tee"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 3.7
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 3,
    "active": true,
    "featured": false
  },
  {
    "id": "411112-cappuccino",
    "title": "Cappuccino",
    "categoryIds": [
      "54683-kaffe-tee"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 3.6
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 4,
    "active": true,
    "featured": false
  },
  {
    "id": "411113-espresso",
    "title": "Espresso",
    "categoryIds": [
      "54683-kaffe-tee"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 2.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 5,
    "active": true,
    "featured": false
  },
  {
    "id": "411114-cay",
    "title": "Cay",
    "description": "Türkischer Schwarztee",
    "categoryIds": [
      "54683-kaffe-tee"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 1.2
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 6,
    "active": true,
    "featured": false
  },
  {
    "id": "411115-frische-minze",
    "title": "Frische Minze",
    "categoryIds": [
      "54683-kaffe-tee"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 4.4
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 7,
    "active": true,
    "featured": false
  },
  {
    "id": "411820-haydari",
    "title": "Haydari",
    "description": "Joghurt / Schafskäse / Dill / Minze / Knoblauch",
    "categoryIds": [
      "54616-kalte-mezze"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 6.5
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 12,
    "active": true,
    "featured": false
  },
  {
    "id": "411821-baba-ganoush",
    "title": "Baba Ganoush",
    "description": "geröstete Aubergine / rote Paprika / Petersilie / Granatapfelsirup / Knoblauch / Walnuss",
    "categoryIds": [
      "54616-kalte-mezze"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 6.5
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 13,
    "active": true,
    "featured": false
  },
  {
    "id": "411822-cerkez-tavugu",
    "title": "Cerkez Tavugu",
    "description": "Hähnchenbrustfilet / Walnuss /  Knoblauch / Olivenöl / Semmelbrösel",
    "categoryIds": [
      "54616-kalte-mezze"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 6.5
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 17,
    "active": true,
    "featured": false
  },
  {
    "id": "411823-semizotu",
    "title": "Semizotu",
    "description": "Feldsalat / Joghurt / Schafskäse",
    "categoryIds": [
      "54616-kalte-mezze"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 6.5
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 14,
    "active": true,
    "featured": false
  },
  {
    "id": "411827-ikitek",
    "title": "IKITEK",
    "description": "Unser Einstieg ins Teilen\n\nKalte Mezze\ngegrilltes Pitabrot\nHummus\nAntalya Piaz\nMütebbel\n\nCoban Salat\n\nHauptgang\ngegrillte Hähnchenspieße\nMeyhane Köfte\n\nDessert\nDessert der Woche",
    "categoryIds": [
      "54773-sharing-menus"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "p.P.",
        "price": 29
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 1,
    "active": true,
    "featured": false
  },
  {
    "id": "411828-altin-gardiyan",
    "title": "ALTIN GARDIYAN",
    "description": "Unsere Signature Auswahl\n\nKalte Mezze\ngegrilltes Pitabrot\nGirit Ezme\nCerkez Tavugu\nMütebbel\nMiso Beete\n\nPaprika-Tomatensalat mit Sesamdressing\n\nWarme Mezze\nPulpo vom Grill\nZuccinibällchen\n\nHauptgang\nEntrecòte\nWolfsbarsch vom Grill\n\nDessert\nDessert der Woche",
    "categoryIds": [
      "54773-sharing-menus"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "p.P.",
        "price": 65
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 2,
    "active": true,
    "featured": false
  },
  {
    "id": "411829-dort-dortluk",
    "title": "DÖRT DÖRTLÜK",
    "description": "vom Land & Meer\n\nKalte Mezze\ngegrilltes Pitabrot\nBaba Ganoush\nMuhammara\nKöpoglu\nArtischocken\n\nTorros Salat\n\nWarme Mezze\nGarnelen in Chilli\n\nHauptgang\nOrtayas Cökertme Kebab\nDorade vom Grill\n\nDessert\nDessert der Woche",
    "categoryIds": [
      "54773-sharing-menus"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "p.P.",
        "price": 45
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 3,
    "active": true,
    "featured": false
  },
  {
    "id": "411830-zucchiniballchen",
    "title": "Zucchinibällchen",
    "description": "knusprige Zuccinibällchen / Käse / Dill / Petersilie",
    "categoryIds": [
      "54771-warme-mezze"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 7.5
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 1,
    "active": true,
    "featured": false
  },
  {
    "id": "411831-pilz-sote",
    "title": "Pilz-Sòte",
    "description": "in der Pfanne geschwenkte Pilze / Chilli / Knoblauchcreme / Kräuter ( optional ohne Chilli)",
    "categoryIds": [
      "54771-warme-mezze"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 7.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 2,
    "active": true,
    "featured": false
  },
  {
    "id": "411832-manti",
    "title": "Manti",
    "description": "türk. Tortellini / Butter / Joghurt / Tomatensud",
    "categoryIds": [
      "54771-warme-mezze"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 7.5
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 3,
    "active": true,
    "featured": false
  },
  {
    "id": "411833-garnelen",
    "title": "Garnelen",
    "description": "mit Knoblauch und Kräutern",
    "categoryIds": [
      "54771-warme-mezze"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 7.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 4,
    "active": true,
    "featured": false
  },
  {
    "id": "411834-schafskase-im-sesammantel",
    "title": "Schafskäse im Sesammantel",
    "description": "Schafskäse / Sesam / Thymian / Honig",
    "categoryIds": [
      "54771-warme-mezze"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 7.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 5,
    "active": true,
    "featured": false
  },
  {
    "id": "411835-hackballchen-in-tomatensugo",
    "title": "Hackbällchen in Tomatensugo",
    "description": "Rinderhackbällchen / Knoblauch / Tomatensugo",
    "categoryIds": [
      "54771-warme-mezze"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 7.5
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 6,
    "active": true,
    "featured": false
  },
  {
    "id": "411836-grillgemuse",
    "title": "Grillgemüse",
    "description": "gegrilltes Gemüse mit Olivenöl und Basilikum",
    "categoryIds": [
      "54774-extras-salate"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 9.5
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 1,
    "active": true,
    "featured": false
  },
  {
    "id": "411837-fatmas-reis",
    "title": "Fatmas Reis",
    "description": "Reis mit Butter verfeinert",
    "categoryIds": [
      "54774-extras-salate"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 3.5
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 2,
    "active": true,
    "featured": false
  },
  {
    "id": "411838-torros-salat",
    "title": "Torros Salat",
    "description": "Grünes, Kirschtomate, gerösteter Sesam,\nGranatapfelkerne",
    "categoryIds": [
      "54774-extras-salate"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 8.9
      }
    ],
    "extras": [
      {
        "id": "extra-1",
        "label": "mit Hähnchenfiletstreifen",
        "price": 4.5
      },
      {
        "id": "extra-2",
        "label": "mit Rinderstreifen",
        "price": 5.5
      }
    ],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 3,
    "active": true,
    "featured": false
  },
  {
    "id": "411839-sommer-salat",
    "title": "Sommer Salat",
    "description": "Feldsalat / Balsamico / Basilikum / Erdbeeren",
    "categoryIds": [
      "54774-extras-salate"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 9.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 4,
    "active": true,
    "featured": false
  },
  {
    "id": "411840-ortayas-coban-salat",
    "title": "ORTAYAS Coban Salat",
    "description": "Tomate, Gurke, Zwiebel, Petersilie,\nSchafskäse",
    "categoryIds": [
      "54774-extras-salate"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 9.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 5,
    "active": true,
    "featured": false
  },
  {
    "id": "411841-mediterraner-brotsalat",
    "title": "Mediterraner Brotsalat",
    "description": "Tomaten / rote Paprika / rote Zwiebeln / Brotcroutons / Tahinidressing",
    "categoryIds": [
      "54774-extras-salate"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 8.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 6,
    "active": true,
    "featured": false
  },
  {
    "id": "411857-dessert-der-woche",
    "title": "Dessert der Woche",
    "description": "jede Woche überlegen wir uns ein neues leckeres Dessert - fragt einfach bei uns nach!",
    "categoryIds": [
      "54775-dessert"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 6.5
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 1,
    "active": true,
    "featured": false
  },
  {
    "id": "411858-burger-pommes",
    "title": "Burger & Pommes",
    "description": "Rinderpatty / Ketchup / Mayo / Cheddar / Pommes",
    "categoryIds": [
      "54787-fur-unsere-kids"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 8.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 1,
    "active": true,
    "featured": false
  },
  {
    "id": "411859-kofte-reis",
    "title": "Köfte & Reis",
    "description": "Butterreis / 3 Köfte",
    "categoryIds": [
      "54787-fur-unsere-kids"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 8.9
      }
    ],
    "extras": [
      {
        "id": "extra-1",
        "label": "Ketchup",
        "price": 0.5
      },
      {
        "id": "extra-2",
        "label": "Mayonaise",
        "price": 0.5
      }
    ],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 2,
    "active": true,
    "featured": false
  },
  {
    "id": "411860-pasta-hackfleischballchen",
    "title": "Pasta & Hackfleischbällchen",
    "description": "Penne mit Hackfleischbällchen in Tomatensauce",
    "categoryIds": [
      "54787-fur-unsere-kids"
    ],
    "variants": [
      {
        "id": "variante-1",
        "label": "",
        "price": 8.9
      }
    ],
    "extras": [],
    "attributes": [],
    "allergens": [],
    "imageUrls": [],
    "order": 3,
    "active": true,
    "featured": false
  }
];
